import { render } from "./BandsAutocomplete.vue?vue&type=template&id=762ad6fe&ts=true"
import script from "./BandsAutocomplete.vue?vue&type=script&lang=ts"
export * from "./BandsAutocomplete.vue?vue&type=script&lang=ts"

import "./BandsAutocomplete.vue?vue&type=style&index=0&id=762ad6fe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__